import React, { useEffect } from "react";
import { FylloButtonGroup, FylloFertigationSummary, ScreenHeader } from "react-library";
import { useNavigate, useParams } from "react-router-dom";
import { getAccessToken } from "../../services/common.service";
import { Routes } from "../../routes";
import { t } from "../../services/locale.service";
import { TBackEvent } from "../../types";
import NutrientReportService from "../../services/nutrientReport.service";

const Fertigation: React.FC = () => {
  const {orgId}=useParams();
  const {plotId} = useParams();
  const token = getAccessToken();
  const navigate = useNavigate();

  const headerTitle = t("fertigation");
  const buttonGroup = [{
    title: t("CreateReport"), 
    id: "create-fertigation-report",
    icon: "pencil"
  }, {
    title: t("ViewHistory"),
    id: "view-summary",
    icon: "history"
  }, {
    title: t("Download"),
    id: "download-fertigation-summary",
    icon: "download"
  }];

  useEffect(() => {
    window.addEventListener("back-icon-press", handleBack);
    window.addEventListener("iconButtonClicked", handleButtonGroup);
    return () => {
      window.removeEventListener("back-icon-press", handleBack);
      window.removeEventListener("iconButtonClicked", handleButtonGroup);
    };
  }, [orgId]);

  const handleBack = (e: Event) => {
    const event = e as TBackEvent;
    const eventKey = event.detail;
    if(eventKey === headerTitle) {
      navigate(Routes.orgHome.replace(":plotId", plotId!));
    }
  };

  const downloadReports = async () => {
    try {
      if(!plotId){
        console.log("No Plot Id Found!");
        return;
      }
      const res = await NutrientReportService.getPlotNutrientReports(plotId!);
      const repordId = res[0].id;
      // pdf will be downloaded
      await NutrientReportService.getNutrientsReportPDF(repordId);
    } catch (error) {
      console.log(error);
    }
  };

  const handleButtonGroup = (e: Event) => {
    const { detail } = e as Event & { detail: { name: string, id: string } };
    if(detail.id === "create-fertigation-report") {
      const createFertigationUrl = Routes.createfertigation.replace(":plotId", plotId!);
      navigate(createFertigationUrl);
    }
    if(detail.id === "view-summary"){
      const nutrientHistoryUrl = Routes.fertigationHistory.replace(":plotId", plotId!);
      navigate(nutrientHistoryUrl);
    }
    if (detail.id === "download-fertigation-summary") {
      downloadReports();
    }
  };

  return (
    <div>
      <ScreenHeader screenName={headerTitle}  /> 
      {
        !plotId && <div> {t("No_Plot_Selected")} </div>
      }
      <div className="p-2">
        <FylloButtonGroup 
          buttonGroup={buttonGroup} 
          className="flex content-center m-y-2"
        />
        <FylloFertigationSummary plotId={plotId} token={token} />
      </div>
    </div>
  );
};

export default Fertigation;